import {Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import React, {useState} from 'react';
import {LoadingOverlay} from '../../../components/LoadingOverlay/LoadingOverlay';
import {OPERATOR} from '../../../graphql/common.datatypes';
import Results from './Results';
import {Page} from '../../../components/Page';
import PageHeader from '../../../components/PageHeader';
import getDocuments from '../getDocuments.api';
import {WcvType} from '../../../graphql/logs.datatypes';
import anyLoading from '../../../utils/anyLoading';
import {WcvDocument} from '../../../graphql/documents.datatypes';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(3)
    },
    results: {
        marginTop: theme.spacing(3)
    }
}));

export interface FilterValues {
    name?: number
}

export const DocumentDownloadListContent = (props: { groupId: number, groupMemberId: number, tourRole: number, isAdmin: boolean }) => {
    const classes = useStyles();
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [page, setPage] = useState(1);
    const [where, setWhere] = useState({
        AND: [
            {column: 'type', operator: OPERATOR.EQ, value: WcvType.GROUP},
            {column: 'type_id', operator: OPERATOR.EQ, value: props.groupId},
            {column: 'available_for_download', operator: OPERATOR.EQ, value: true},
            {OR: [
                    {column: 'tour_role', operator: OPERATOR.EQ, value: -1},
                    {column: 'tour_role', operator: OPERATOR.EQ, value: props.tourRole},
            ]}
        ],
    });

    const [orderBy] = useState([{column: 'created_at', order: 'DESC'}]);
    const groupDocumentsData = getDocuments(rowsPerPage, page, where, orderBy);
    const loadingData = anyLoading(groupDocumentsData);

    return (
        <React.Fragment>
            <LoadingOverlay loading={loadingData.loading}>
                {groupDocumentsData && groupDocumentsData.data && groupDocumentsData.data.documents && (
                    <Results
                        className={classes.results}
                        groupMemberId={props.groupMemberId}
                        documents={groupDocumentsData.data.documents.data}
                        paginatorInfo={groupDocumentsData.data.documents.paginatorInfo}
                        isAdmin={props.isAdmin}
                        setPage={setPage}
                        rowsPerPage={rowsPerPage}
                        setRowsPerPage={setRowsPerPage}
                    />
                )}
            </LoadingOverlay>
        </React.Fragment>
    );
};

const DocumentsDownloadList = (props: { tourRole: number, groupId: number, groupMemberId: number, isAdmin: boolean }) => {
    const classes = useStyles();
    const title = 'Documents';
    return (
        <Page className={classes.root} title={title}>
            <PageHeader section="documents" title={title}/>
            <DocumentDownloadListContent {...props}/>
        </Page>
    );
};


export default DocumentsDownloadList;
